// Module
var code = `<section class="box">
  <holiday-table
    holidays="\$ctrl.loanProduct.loanHolidays"
    on-add="\$ctrl.addHoliday()"
    on-delete="\$ctrl.removeHoliday(idx)"
    on-save="\$ctrl.saveHoliday(form, index)"
    on-cancel-add="\$ctrl.cancelAddHoliday()"
    update-enabled="true"
    on-edit="\$ctrl.editHoliday(index)"
    on-cancel-edit="\$ctrl.cancelEditHoliday(form, index)"
    save-disabled="\$ctrl.isSaveDisabled(form)"
    form="\$ctrl.form"
  >
  </holiday-table>
</section>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/loan/details/forms/loan-product-holidays.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;